import { Card, FAQ } from './types';

export const devisionCards: Card[] = [
  {
    id: 1,
    icon: 'card-icon_account-manager.svg',
    title: 'Account Manager – Your Personal Business Coordinator',
    description: 'Being part of DFA adds immediate trust to your name in the freight forwarding industry. With a community that only includes verified, dependable professionals, you instantly show your partners and clients that reliability is at the heart of your business. This credibility opens doors to new markets and opportunities.',
    alt: 'Account Manager',
  },
  {
    id: 2,
    icon: 'card-icon_rates-manager.svg',
    title: 'Rates Manager – Keeping Your Pricing System in Check',
    description: 'Forget the hassle of managing your rates! DFA\'s Rates Manager ensures your shipping rates are updated and accurate. Simply send your rates in any format, and within 24 hours, they’ll be processed and reflected on our platform. It’s seamless rate management designed to keep your operations efficient and up-to-date.',
    alt: 'Rates Manager',
  },
  {
    id: 3,
    icon: 'card-icon_call-center.svg',
    title: 'Call Centre – Always Available for Your Needs',
    description: 'Around-the-clock support that’s just a call, email, or message away. Our dedicated call centre team is ready to assist with any question or issue, ensuring you get the help you need, exactly when you need it.',
    alt: 'Call Centre',
  },
];

export const supportBenefitsCards: Card[] = [
  {
    id: 1,
    icon: 'card-icon_expert-assistant.svg',
    title: 'Expert Assistance at Your Fingertips',
    description: 'No matter the issue, our global support team offers personalized guidance around the clock to keep your operations on track.',
    alt: 'Expert Assistance',
  },
  {
    id: 2,
    icon: 'card-icon_troubleshooting.svg',
    title: 'Troubleshooting Made Easy',
    description: 'From complex freight queries to simple day-to-day challenges, we ensure smooth sailing with prompt, tailored solutions.',
    alt: 'Troubleshooting',
  },
  {
    id: 3,
    icon: 'card-icon_proactive.svg',
    title: 'Proactive Problem-Solving',
    description: 'We don’t just wait for issues to arise; our proactive approach addresses potential concerns before they disrupt your business.',
    alt: 'Problem-Solving',
  },
  {
    id: 4,
    icon: 'card-icon_streamlining.svg',
    title: 'Operational Streamlining',
    description: 'Receive expert advice on optimising your workflow, cutting costs, and enhancing productivity without compromising quality.',
    alt: 'Operational Streamlining',
  },
  {
    id: 5,
    icon: 'card-icon_connectivity.svg',
    title: 'Seamless Global Connectivity',
    description: ' Leverage our worldwide network and dedicated tools to collaborate effortlessly with international partners.',
    alt: 'Global Connectivity',
  },
];

export const faq: FAQ[] = [
  {
    id: "1",
    question: "What does DFA Support offer?",
    answer: (cn: Function) => (
      `
        <p class='${cn('faq__answer-paragraph')}'>
          DFA Support provides freight forwarders with 24/7 assistance for operational challenges, business advice, and proactive solutions to enhance efficiency and reliability.
        </p>
      `
    ),
  },
  {
    id: "2",
    question: "How quickly can I get assistance?",
    answer: (cn: Function) => (
      `
        <p class='${cn('faq__answer-paragraph')}'>
          Our support team is available around the clock, ensuring rapid responses to your queries and immediate solutions to challenges.
        </p>
      `
    ),
  },
  {
    id: "3",
    question: "Is DFA Support available globally?",
    answer: (cn: Function) => (
      `
        <p class='${cn('faq__answer-paragraph')}'>
          Yes, our support services are accessible worldwide, offering freight forwarders consistent assistance regardless of location.
        </p>
      `
    ),
  },
  {
    id: "4",
    question: "What kind of expertise does your support team have?",
    answer: (cn: Function) => (
      `
        <p class='${cn('faq__answer-paragraph')}'>
          Our team consists of logistics experts with hands-on experience, well-versed in addressing the unique challenges of the freight forwarding industry.
        </p>
      `
    ),
  },
  {
    id: "5",
    question: "How can DFA Support help my business grow?",
    answer: (cn: Function) => (
      `
        <p class='${cn('faq__answer-paragraph')}'>
          DFA Support enables you to overcome operational hurdles, improve workflows, and offer reliable services, building trust with clients and enhancing growth potential.
        </p>
      `
    ),
  },
  {
    id: "6",
    question: "What sets DFA Support apart from other services?",
    answer: (cn: Function) => (
      `
        <p class='${cn('faq__answer-paragraph')}'>
          Our industry-specific focus, proactive approach, and 24/7 global availability make DFA Support uniquely positioned to address freight forwarders' needs effectively.
        </p>
      `
    ),
  },
  {
    id: "7",
    question: "Is the support tailored to my business needs?",
    answer: (cn: Function) => (
      `
        <p class='${cn('faq__answer-paragraph')}'>
          Absolutely. DFA Support provides customised solutions tailored to your operations, ensuring the best outcomes for your business.
        </p>
      `
    ),
  },
];